import { SoledadUtils } from './../../lib/helpers/utils';

export interface Delivery {
    numero: string;
    referencia: string;
    serie: string;

    albaran: string;
    albaranAnio: string;
    articulos: string;

    cliente: string;
    nombreCliente: string;

    encarga: string;
    estado: number;
    fecha: Date;
    fechahora: Date;
    fechaEntrega: string; //Viene con formato del servicio

    iva: number;
    descuento1: number;
    descuento2: number;
    descuentoTotal: number;
    baseImponible: number;
    importeBruto: number;
    importeDescuento1: number;
    importeDescuento2: number;
    importeTotal: number;
    almacen: string;
    
    URL_PDF: string;

    tracking: string;
}

export class DeliveryHelper {

    static create() {
        return {
            numero: '',
            referencia: '',
            serie: '',
            albaran: '',
            albaranAnio: '',
            articulos: '',
            cliente: '',
            nombreCliente: '',
            encarga: '',
            estado: 0,
            fecha: null,
            fechahora: null,
            fechaEntrega: '',
            iva: 0,
            descuento1: 0,
            descuento2: 0,
            descuentoTotal: 0,
            baseImponible: 0,
            importeBruto: 0,
            importeDescuento1: 0,
            importeDescuento2: 0,
            importeTotal: 0,
            tracking: '',
            almacen: ''
        };
    }

    static transformFromAPI(apiData: Object) {

        const obj = DeliveryHelper.create();
        obj.albaran = apiData['PE_ALBARAN'];
        obj.albaranAnio = apiData['PE_ALBARANANIO'];
        obj.articulos = apiData['PE_LINEAS'];
        obj.baseImponible = apiData['PE_BASEIMPONIBLE'];
        obj.cliente = apiData['PE_CLIENTE'];
        obj.descuento1 = apiData['PE_DESCUENTO1'];
        obj.descuento2 = apiData['PE_DESCUENTO2'];
        obj.descuentoTotal = apiData['PE_DESCUENTOTOTAL'];
        obj.encarga = apiData['PE_ENCARGA'];
        obj.estado = apiData['PE_ESTADO'];
        obj.fecha = SoledadUtils.dateTimeParse(apiData['PE_FECHA']);
        obj.fechahora = SoledadUtils.dateTimeParse(apiData['PE_FECHAHORA']);
        obj.fechaEntrega = apiData['PE_FECHAENTREGA'];
        obj.importeBruto = apiData['PE_IMPORTEBRUTO'];
        obj.importeDescuento1 = apiData['PE_IMPORTEDESCUENTO1'];
        obj.importeDescuento2 = apiData['PE_IMPORTEDESCUENTO2'];
        obj.importeTotal = apiData['PE_IMPORTETOTAL'];
        obj.iva = apiData['PE_IVA'];
        obj.nombreCliente = apiData['PE_NOMBRECLIENTE'];
        obj.numero = apiData['PE_NUMERO'];
        obj.referencia = apiData['PE_REFERENCIA'];
        obj.serie = apiData['PE_SERIE'];
        obj.tracking = apiData['PE_TRACKING'];
        obj.almacen = ''+apiData['PE_ALMACEN'];

        return obj;
    }
}
